__turbopack_context__.v({
  "container": "ApplyFormLabel-module__SLbt3a__container",
  "error": "ApplyFormLabel-module__SLbt3a__error",
  "fadeInItems": "ApplyFormLabel-module__SLbt3a__fadeInItems",
  "spacing--lg": "ApplyFormLabel-module__SLbt3a__spacing--lg",
  "spacing--md": "ApplyFormLabel-module__SLbt3a__spacing--md",
  "spacing--sm": "ApplyFormLabel-module__SLbt3a__spacing--sm",
  "spacing--xl": "ApplyFormLabel-module__SLbt3a__spacing--xl",
  "spacing--xs": "ApplyFormLabel-module__SLbt3a__spacing--xs",
  "spacing--xxl": "ApplyFormLabel-module__SLbt3a__spacing--xxl",
  "spacing--xxs": "ApplyFormLabel-module__SLbt3a__spacing--xxs",
  "spacing--xxxl": "ApplyFormLabel-module__SLbt3a__spacing--xxxl",
  "spacing--xxxs": "ApplyFormLabel-module__SLbt3a__spacing--xxxs",
});
